import type { User } from 'oidc-client';
import React, { useMemo } from 'react';
import { ConnectHeader } from '../../headerFooter';
import { readUniversalLinkParams } from '../searchParams/searchParams';

type AuthenticatedHeaderProps = {
  user: User;
};

export function AuthenticatedHeader({
  user
}: AuthenticatedHeaderProps): JSX.Element {
  const { projectId } = readUniversalLinkParams();

  const customHeaderOptions = useMemo(
    () => ({
      ShowNotificationsButton: true,
      ShowHelpButton: true,
      ShowFullName: true,
      Icon: {
        ImageLocation: window.location.origin + '/Bentley_Logo.png'
      }
    }),
    []
  );

  return (
    <ConnectHeader
      userEmail={user.profile.email ?? ''}
      dataAccessLevel="WorkArea"
      showSecondaryHeader={false}
      contextId={projectId ?? undefined}
      customHeaderOptions={customHeaderOptions}
    />
  );
}
